var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.643,
    height: 50,
    viewBox: "0 0 65.643 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_132474",
    "data-name": "Group 132474",
    transform: "translate(-482.25 -461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_128777",
    "data-name": "Group 128777",
    transform: "translate(491.713 461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "heart",
    d: "M29.34,52.35a6.311,6.311,0,0,1-2.014-.3,37.911,37.911,0,0,1-7.486-3.675,46.179,46.179,0,0,1-8.549-6.832A36.834,36.834,0,0,1,4.211,31.55,30.472,30.472,0,0,1,1.25,18.431,16.073,16.073,0,0,1,17.323,2.35a15.832,15.832,0,0,1,7.3,1.757A16.153,16.153,0,0,1,29.34,7.785,16,16,0,0,1,41.357,2.35,16.073,16.073,0,0,1,57.43,18.431,30.472,30.472,0,0,1,54.469,31.55a36.834,36.834,0,0,1-7.081,9.994,46.178,46.178,0,0,1-8.549,6.832,37.91,37.91,0,0,1-7.486,3.675A6.311,6.311,0,0,1,29.34,52.35ZM17.323,4.388A14.05,14.05,0,0,0,3.3,18.431c0,9.952,5.144,17.288,9.459,21.689a42.464,42.464,0,0,0,15.236,10l.01,0a4.942,4.942,0,0,0,2.675,0l.01,0a42.464,42.464,0,0,0,15.236-10c4.315-4.4,9.459-11.738,9.459-21.689a14,14,0,0,0-25.22-8.419,1.027,1.027,0,0,1-1.644,0A13.85,13.85,0,0,0,17.323,4.388Z",
    transform: "translate(-1.25 -2.35)",
    fill: "#09143a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    transform: "translate(482.25 476.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91217",
    "data-name": "Path 91217",
    d: "M30.16,20.586c-.524,0-1.5-.25-2.173-1.926l-3-7.577A4.686,4.686,0,0,0,21.022,8.39L5.247,8.443A1.024,1.024,0,1,1,5.24,6.4l15.778-.053a6.733,6.733,0,0,1,5.871,3.983l3,7.577a2.5,2.5,0,0,0,.271.52,2.519,2.519,0,0,0,.272-.524l6.02-15.274c.585-1.489,1.523-1.759,2.03-1.787A2.377,2.377,0,0,1,40.7,2.392l2.735,5.181A4.8,4.8,0,0,0,47.187,9.84H57.864a1.024,1.024,0,1,1,0,2.048H47.187a6.806,6.806,0,0,1-5.561-3.361L38.892,3.348a1.572,1.572,0,0,0-.292-.414,1.574,1.574,0,0,0-.243.442L32.335,18.655C31.663,20.335,30.684,20.586,30.16,20.586Z",
    transform: "translate(-4.22 -0.836)",
    fill: "#09143a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLife);
export default __webpack_public_path__ + "static/media/life.73068467e64f3c107d0ee0f9bdc8b77d.svg";
export { ForwardRef as ReactComponent };